import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { TargetAudience } from './components/TargetAudience';
import { Creator } from './components/Creator';
import { AccessDetails } from './components/AccessDetails';
import { Results } from './components/Results';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const pixelId = '2577074439374941';
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-[#0B1426] text-gray-100 font-sans selection:bg-blue-500/30" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      <Hero data-id="element-2" />
      <PainPoints data-id="element-3" />
      <Solution data-id="element-4" />
      <Modules data-id="element-5" />
      <Bonuses data-id="element-6" />
      <TargetAudience data-id="element-7" />
      <Creator data-id="element-8" />
      <AccessDetails data-id="element-9" />
      <Results data-id="element-10" />
      <Testimonials data-id="element-11" />
      <Pricing data-id="element-12" />
      <Guarantee data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}